import React from "react";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { Button, FormLabel, Row, Col, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { ReportService } from "../services/ReportService.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  InputTextbox,
  AlertToolBox,
  ShowError,
  DatePickerComponent_adv,
  MultiViewPopup,
  ProgressBar,
  CollapseComponent,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { BaseBean } from "../ds/client_ds.js";
import {
  RestReadRequest,
  RestPageListBean,
  CustomerServiceInquiryCriteria,
  RestCustomerListRequest,
  CustomerSearchCriteria,
  CreditMemoSearchCriteria,
  CreditMemoDetailsRequest,
} from "../ds/ds.js";
import {
  PopupCreditMemoModule,
  PopupCustomerModule,
} from "../modules/ModuleUtil.js";
import { CustomerService } from "../services/CustomerService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CreditMemoDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "CreditMemoDetails Inquiry",
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlert: false,
      alertMsg: "",
      error_list: [],
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      criteria: new CreditMemoSearchCriteria(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      creditMemoTypes: [],
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditTypeList: true,
      isInquiryDatasFound: false,
      inquiryDataList: [],
      summaryData: null,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
      isDisableFields: false,
      isShowCustomerModule: false,
      isCollapsible_open: true,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let creditMemoTypes = [];
    creditMemoTypes = attribute_cache.creditMemoTypes;
    if (!isEmptyArray(creditMemoTypes)) {
      this.state.creditMemoTypes = creditMemoTypes;
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let creditTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.creditMemoTypes,
      "creditMemoTypes"
    );
    this.setState({ creditTypeLookupHandler: creditTypeLookupHandler });
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearCriteria = () => {
    let tempCriteria = new CreditMemoSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    tempCriteria.salesPersonName = "";
    this.setState({
      criteria: tempCriteria,
      isDisableFields: false,
      isCollapsible_open: true,
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  resetInquiry = () => {
    let tempCriteria = new CustomerServiceInquiryCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CreditMemoDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CreditMemoDetailsInquiryPDFReport_IsAccessible()
      ) {
      ReportService.generateCreditMemoDetailsReport(
        listRequest,
        this.generateCreditmemoPageResponse,
        this.errorCallBack
      );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CreditMemoDetailsInquiryExcelReport_IsAccessible()
      ) {
      ReportService.generateCreditMemoDetailsReport(
        listRequest,
        this.generateCreditmemoPageResponseForExcel,
        this.errorCallBack
      );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCreditmemoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCreditmemoPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          // window.open(this.report_url + reportFilePath);
            let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCreditMemoInquiryList(criteria);
  };
  loadCreditMemoInquiryList = (criteria) => {
    // if (SecurityAccessManager.CreditMemoDetailsInquiry_IsAccessible()) {
    ReportService.getCreditMemoInquiryDetails(
      criteria,
      this.loadCreditMemoPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadCreditMemoPageResponse = (response) => {
    if (response.data != null && response.data.creditMemoDetailsList != null) {
      let summaryData = [];
      let invoiceInfoDataList = [];
      summaryData = response.data.creditMemoDetailsList;
      if (!isEmptyArray(response.data.creditMemoDetailsList.creditMemos)) {
        invoiceInfoDataList = response.data.creditMemoDetailsList.creditMemos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: invoiceInfoDataList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        summaryData: summaryData,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.errorCallBack
    );
  };
  editCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ customerData: customerData, criteria: criteria });
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (response.data != null && response.data.customerPageList != null) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };

  creditTypeOnChange = (e) => {
    let creditType = e.target.value;
    this.state.isShowAutoCompleteCreditTypeList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
    if (isEmpty(creditType)) {
      this.state.isShowAutoCompleteCreditTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
      let tempData = this.state.criteria;
      tempData.creditMemoType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempData,
        creditTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "creditMemoType" &&
      showAutoCompleteList === true &&
      creditType !== ""
    ) {
      this.readCreditTypeBySearchString(e.target.value);
      this.readCreditType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempData });
  };
  creditTypeEnterKeyEvent = (e) => {
    this.readCreditType(e.target.value);
    this.state.isShowAutoCompleteCreditTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
    this.setState({
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCreditTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCreditTypeList: isShowAutoCompleteList,
    });
  };
  readCreditTypeBySearchString = (searchString) => {
    let creditTypeData = this.state.creditMemoTypes;
    let simpleAutoCompleteList = new Array();
    if (creditTypeData.length > 0 && creditTypeData != null) {
      creditTypeData.map((obj) => {
        let creditTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(creditTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      creditTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCreditType = (creditType) => {
    let tempData = this.state.criteria;
    let creditTypeBean = null;
    let creditTypeData = null;
    this.state.creditMemoTypes.map((ln) => {
      if (ln.code === creditType) {
        creditTypeBean = ln;
        creditTypeData = new BaseBean();
        creditTypeData.code = ln.code;
        creditTypeData.description = ln.description;
      }
    });
    if (!isEmpty(creditTypeBean)) {
      tempData.creditMemoType = creditTypeBean.code;
      this.state.isShowAutoCompleteCreditTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
      this.setState({
        criteria: tempData,
        isShowAutoCompleteCreditTypeList: showAutoCompleteList,
      });
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCreditMemoModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  showHideSecondHeader = () => {
    let isCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: isCollapsible_open });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CR#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
     columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditType", "creditType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Currency", "companyCurrencyCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Credit", "totalCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalCreditAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Open Amt", "nonMerchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalOpenAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Applied Amt", "appliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalAppliedAmount")
    );
    return columns;

  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let summaryDetail = this.state.summaryData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          onChange={this.onChange}
          creditTypeOnChange={this.creditTypeOnChange}
          creditTypeEnterKeyEvent={this.creditTypeEnterKeyEvent}
          displayCreditTypeAutoCompleteList={
            this.displayCreditTypeAutoCompleteList
          }
          creditMemoTypes={this.state.creditMemoTypes}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              subHeaderData={summaryDetail}
            />
          </div>
        )}
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      creditMemoTypes: this.props.creditMemoTypes,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }

  onChange = (e) => {
    this.props.onChange(e);
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  creditTypeOnChange = (e) => {
    this.props.creditTypeOnChange(e);
  };
  creditTypeEnterKeyEvent = (e) => {
    this.props.creditTypeEnterKeyEvent(e);
  };
  displayCreditTypeAutoCompleteList = () => {
    this.props.displayCreditTypeAutoCompleteList();
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      this.props.showHideSecondHeader();
    }
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.customerCodeRef}
              name="customerCode"
              onChange={this.customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={this.props.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteCustomerList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              onChange={this.onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>From Date</FormLabel>
          </Col>



          <Col sm="2">

            <DatePickerComponent_adv
              name="startDate"
              onChange={this.onChange}
              value={criteria.startDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Date</FormLabel>
          </Col>

        
          <Col sm="2">

            <DatePickerComponent_adv
              name="stopDate"
              onChange={this.onChange}
              value={criteria.stopDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              <FormLabel>Type</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.creditTypeOnChange}
                placeholder="creditMemoType"
                name="creditMemoType"
                value={criteria.creditMemoType}
                lookupRequired={true}
                lookupHandler={this.props.creditTypeLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.creditTypeEnterKeyEvent}
                autoCompleteListData={
                  this.props.creditTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayCreditTypeAutoCompleteList}
                showAutoCompleteList={
                  this.props.isShowAutoCompleteCreditTypeList
                }
                disabled={isDisableFields}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
  


function CreditMemoDetailsInquiry(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <CreditMemoDetails {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default CreditMemoDetailsInquiry;
